




































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import { Prop, Watch } from 'vue-property-decorator'
import { Job, CrudDialogMode, Branch } from '../utils/types'

@Component
export default class JobCrud extends Vue {
  @Getter branches!: Branch[]
  @Action fetchBranches!: (payload: {limit: number; page: number}) => Promise<void>
  @Prop(String) title!: string
  @Prop(Object) job?: Job
  @Prop(Number) mode!: CrudDialogMode
  data: Job = {
    id: this.job?.id ?? '',
    name: this.job?.name ?? undefined,
    isVerified: this.job?.isVerified ?? true,
    address: this.job?.address ?? '',
    branch: this.job?.branch ?? { name: '' } as Branch,
    isArchived: this.job?.isArchived ?? false
  }

  selectedBranch = this.job?.branch?.id ?? ''

  @Watch('job')
  onJobPropChange () {
    this.data = {
      id: this.job?.id ?? '',
      name: this.job?.name ?? '',
      isVerified: this.job?.isVerified ?? true,
      address: this.job?.address ?? '',
      branch: this.job?.branch ?? { name: '' } as Branch,
      isArchived: this.job?.isArchived ?? false
    }
    this.selectedBranch = this.job?.branch?.id ?? ''
  }

  emitClose () {
    this.$emit('close')
  }

  async mounted () {
    await this.fetchBranches({ limit: 100, page: 1 })
  }

  emitSubmit () {
    if (this.data?.branch) {
      this.data.branch.id = this.selectedBranch
    }
    this.$emit('submit', this.data)
  }

  get isFormVisible () {
    return (
      this.mode === CrudDialogMode.CREATE || this.mode === CrudDialogMode.EDIT
    )
  }

  get selectableBranches () {
    return this.branches.map(item => ({ text: item.name, value: item.id }))
  }
}
